module["exports"] = ["### ###-####", "1 ### ###-####", "### ###-####, poste ###"];